import type { IWarehouseApi } from "../../../api/WarehouseApi";
import type { Box as BoxModel } from "../../../stores/Box";
import type { INavigationStore } from "../../../stores/navigation";
import type { BoxPageOperationBindings } from "./operations-controller";

export function createBoxPageOperationBindings(input: {
  api: IWarehouseApi;
  navigationStore: INavigationStore;
  box: BoxModel;
  isNestedMutationLocked: () => boolean;
  canDeleteCurrentBoxNow: () => boolean;
  setBusyProductId: (id: string | null) => void;
  setBusyBoxId: (id: string | null) => void;
  setIsDeletingCurrentBox: (value: boolean) => void;
  clearActionError: () => void;
  setActionError: (message: string) => void;
  reload: () => Promise<void>;
}): BoxPageOperationBindings {
  return {
    api: input.api,
    navigationStore: input.navigationStore,
    box: input.box,
    isNestedMutationLocked: input.isNestedMutationLocked,
    canDeleteCurrentBoxNow: input.canDeleteCurrentBoxNow,
    setBusyProductId: input.setBusyProductId,
    setBusyBoxId: input.setBusyBoxId,
    setIsDeletingCurrentBox: input.setIsDeletingCurrentBox,
    clearActionError: input.clearActionError,
    setActionError: input.setActionError,
    reload: input.reload,
  };
}
